import LessonOpenMessageBox from './LessonOpenMessageBox';
import Overlay from '../../shared/components/Overlay';
import React from 'react';
import Typography from '@mui/material/Typography';
import usePathwayLessonLaunch from '../hooks/usePathwayLessonLaunch';

interface PathwayLessonPlayerProps {
  lessonWindow: Window;
  title: string;
  username: string;
  zonekey: number;
  pathkey: string;
  lessonkey: string;
  resultkey: string;
  targetOrigin: string;
  onMessage: (event?: MessageEvent) => void; //* The 'event' is optional for use to close the lesson instead of 'lessonComplete' message.
}

const PathwayLessonPlayer = (props: PathwayLessonPlayerProps) => {
  const {
    lessonWindow,
    title,
    username,
    zonekey,
    pathkey,
    lessonkey,
    resultkey,
    targetOrigin
  } = props;

  const { loading, error, url } = usePathwayLessonLaunch(
    username,
    zonekey,
    pathkey,
    lessonkey,
    resultkey,
    targetOrigin
  );

  const handleMessage = (event: MessageEvent) => {
    if (url && url.startsWith(event.origin)) {
      lessonWindow.close();
      window.removeEventListener('message', handleMessage);
      props.onMessage(event);
    }
  };

  function closeLesson() {
    lessonWindow.close();
    window.removeEventListener('message', handleMessage);
    props.onMessage();
  }

  const onLessonLoad = () => {
    window.addEventListener('message', handleMessage);
  };

  if (loading) {
    return <Overlay spinner message="Loading..." />;
  }
  if (error) {
    return (
      <div>
        <Typography variant="h6">Failed to open lesson.</Typography>
        <Typography variant="subtitle1">{error.message}</Typography>
      </div>
    );
  }
  if (url && lessonWindow) {
    lessonWindow.location.href = url;
    onLessonLoad();
  }

  return <LessonOpenMessageBox title={title} onConfirm={closeLesson} />;
};

export default PathwayLessonPlayer;
